import { Json } from '@ff-os/shared-json/Json';
import { FillStyleOverrides, PaintTarget } from './targets';

export const applyPalette = (color: string, palette?: Json.Palette) => {
    return palette?.[color] || color;
};

export const mapFillStyleTo = (
    target: PaintTarget,
    input: { fillStyle: string },
    overrides: FillStyleOverrides,
    palette: Json.Palette
) => {
    return mapTo(target, {
        mockup: applyOverride(input.fillStyle, overrides.mockupFillStyle, palette),
        icon: applyOverride(input.fillStyle, overrides.iconFillStyle, palette),
        print: applyOverride(input.fillStyle, overrides.printFillStyle, palette),
        preview3d: applyOverride(input.fillStyle, overrides.preview3dFillStyle, palette)
    });
};

const mapTo = <T>(target: PaintTarget, options: { [key in PaintTarget]: T }) => {
    return options[target];
};

const applyOverride = (
    inputFillStyle: string,
    fillStyleOverride: string | undefined,
    palette: Json.Palette
) => {
    if (fillStyleOverride) {
        return applyPalette(fillStyleOverride, palette);
    } else {
        return applyPalette(inputFillStyle, palette);
    }
};